import React from "react";
import { Modal, Button, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Select, Slider } from "antd";
import {
  activityGroupFetch,
  advanceSearchValuesClear,
  agClear,
  oppFetch,
  potentialFetch,
  productClear,
  productFetch,
  selectLicenseList,
  setActivityGroups,
  setAdvanceSearchValue,
  setModalStats,
  setProducts,
  setSectors,
  setSubSectors,
  stateDeleteHandler,
  subSectorClear,
  subSectorFetch,
} from "../../api/redux";
import { Formik } from "formik";
import {
  cityClear,
  cityFetch,
  organizationClear,
  organizationFetch,
  partClear,
  partFetch,
  ruralAreaClear,
  ruralAreaFetch,
  selectPartList,
  setCities,
  setParts,
  setRuralAreas,
  setUnits,
  setVillages,
  townshipFetch,
  unitClear,
  unitFetch,
  villageClear,
  villageFetch,
} from "../../api/partsRedux";
import { searchLog } from "../../api/crud";
import config from "../../../../config/config";

const { Option, OptGroup } = Select;

export default () => {
  const state = useSelector(selectLicenseList);
  const dispatch = useDispatch();

  const [amount, setAmount] = React.useState([1, 1000]);
  const partState = useSelector(selectPartList);

  const onClose = () => {
    dispatch(setModalStats(false));
  };

  const fieldValueSetter = (key, value) => {
    dispatch(setAdvanceSearchValue({ key, value }));
  };

  const marks = {
    1: "1",
    250: "250",
    500: {
      label: <strong>500 میلیارد ریال</strong>,
    },
    750: "750",
    1000: "1000",
  };

  const filterHandler = (state, id) => {
    const filtered = state.filter((el) => {
      return el.id !== id;
    });
    return filtered;
  };

  React.useEffect(() => {
    dispatch(townshipFetch());
    dispatch(organizationFetch());
  }, []);

  return (
    <Modal
      title="جست و جو پیشرفته"
      className="as-modal"
      footer={false}
      width={"75%"}
      visible={state.modalStats}
      onCancel={onClose}
    >
      <div
        className="d-flex flex-column flex-wrap gap-10"
        style={{ padding: "25px" }}
      >
        <Formik
          enableReinitialize
          initialValues={{
            ...state.advanceSearchValue,
            min: amount[0],
            max: amount[1],
          }}
          onSubmit={(values) => {}}
        >
          {({ handleSubmit, setFieldValue, values, setValues }) => {
            return (
              <>
                <div className="row">
                  {" "}
                  <div className="col-12">
                    <h6 className="my-auto text-right mb-1rem ">
                      فیلتر بر اساس عنوان
                    </h6>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      size={"large"}
                      className="w-100 search-fields"
                      placeholder="انتخاب عنوان فرصت"
                      direction="rtl"
                      value={values.title}
                      showArrow={true}
                      key={1}
                      allowClear
                      onSelect={(e, a) => {
                        setFieldValue("title", e);
                      }}
                      onClear={(e, a) => {
                        setFieldValue("title", null);
                      }}
                    >
                      {state.oppTitles &&
                        state.oppTitles.map((el) => {
                          return (
                            <Option className="text-right" value={el.title}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  {config.isPotentialAvailable && (
                    <div className="col-12 col-md-3">
                      <Select
                        size={"large"}
                        className="w-100 search-fields"
                        placeholder="انتخاب عنوان پتانسیل"
                        direction="rtl"
                        value={values?.potentialTitle}
                        showArrow={true}
                        key={1}
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .match(input.toLowerCase())
                        }
                        allowClear
                        onSelect={(e, a) => {
                          setFieldValue("potentialTitle", e);
                        }}
                        onClear={(e, a) => {
                          setFieldValue("potentialTitle", null);
                        }}
                      >
                        {state.potentialsTitles &&
                          state.potentialsTitles.map((el) => {
                            return (
                              <Option className="text-right" value={el.title}>
                                {el.title}
                              </Option>
                            );
                          })}
                      </Select>
                    </div>
                  )}
                  <div className="col-12">
                    <h6 className="my-auto text-right mb-1rem ">
                      فیلتر بر اساس بخش و نوع سرمایه گذاری
                    </h6>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      size={"large"}
                      className="w-100 search-fields"
                      placeholder="انتخاب بخش"
                      direction="rtl"
                      value={values.sectorId}
                      showArrow={true}
                      key={1}
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      onSelect={(e, a) => {
                        dispatch(setSubSectors(null));
                        dispatch(setActivityGroups(null));
                        dispatch(setProducts(null));

                        setFieldValue("sectorId", e);
                        setFieldValue("subSectorId", null);
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);

                        dispatch(subSectorFetch({ sectorId: e }));
                      }}
                      onClear={(e, a) => {
                        setFieldValue("sectorId", null);
                        setFieldValue("subSectorId", null);
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);

                        dispatch(setProducts(null));
                        dispatch(setActivityGroups(null));
                        dispatch(setSubSectors(null));
                      }}
                    >
                      {state.sectors &&
                        state.sectors.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب زیربخش"}
                      showArrow={true}
                      value={values.subSectorId}
                      direction="rtl"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      allowClear
                      key={2}
                      onSelect={(e, a) => {
                        dispatch(setActivityGroups(null));
                        dispatch(setProducts(null));

                        setFieldValue("subSectorId", e);
                        setFieldValue("productId", null);
                        setFieldValue("activityGroupId", null);

                        dispatch(activityGroupFetch({ subSectorId: e }));
                      }}
                      onClear={(e, a) => {
                        setFieldValue("subSectorId", null);
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);

                        dispatch(setProducts(null));

                        dispatch(setActivityGroups(null));
                      }}
                    >
                      {state.subSectors &&
                        state.subSectors.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب گروه فعالیت"}
                      showArrow={true}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      key={3}
                      allowClear
                      direction="rtl"
                      value={values.activityGroupId}
                      onSelect={(e, a) => {
                        dispatch(setProducts(null));

                        setFieldValue("activityGroupId", e);
                        setFieldValue("productId", null);

                        dispatch(productFetch({ activityGroupId: e }));
                      }}
                      onClear={(e, a) => {
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);

                        dispatch(setProducts(null));
                      }}
                    >
                      {state.activityGroups &&
                        state.activityGroups.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب محصول"}
                      showArrow={true}
                      direction="rtl"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      value={values.productId}
                      allowClear
                      key={4}
                      onSelect={(e, a) => {
                        setFieldValue("productId", e);
                      }}
                    >
                      {state.products &&
                        state.products.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h6 className="my-auto text-right mb-1rem ">
                      فیلتر بر اساس تقسیمات استانی
                    </h6>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب شهرستان"}
                      showArrow={true}
                      direction="rtl"
                      value={values?.townshipId}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      key={4}
                      allowClear
                      onSelect={(e, a) => {
                        dispatch(setParts(null));
                        dispatch(setCities(null));
                        dispatch(setVillages(null));

                        setFieldValue("townshipId", e);
                        setFieldValue("partId", null);
                        setFieldValue("cityId", null);
                        setFieldValue("villageId", null);

                        dispatch(partFetch({ townshipId: e }));
                      }}
                      onClear={() => {
                        setFieldValue("townshipId", null);
                        setFieldValue("partId", null);
                        setFieldValue("cityId", null);
                        setFieldValue("villageId", null);

                        dispatch(setParts(null));
                        dispatch(setCities(null));
                        dispatch(setVillages(null));
                      }}
                    >
                      {partState.townships &&
                        partState.townships.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب بخش"}
                      showArrow={true}
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      direction="rtl"
                      value={values.partId}
                      key={4}
                      onSelect={(e, a) => {
                        dispatch(setCities(null));
                        dispatch(setVillages(null));
                        dispatch(setRuralAreas(null));

                        setFieldValue("partId", e);
                        setFieldValue("cityId", null);
                        setFieldValue("ruralAreaId", null);

                        dispatch(cityFetch({ partId: e }));
                        dispatch(ruralAreaFetch({ partId: e }));
                      }}
                      onClear={() => {
                        setFieldValue("partId", null);
                        setFieldValue("cityId", null);
                        setFieldValue("ruralAreaId", null);

                        dispatch(setCities(null));
                        dispatch(setVillages(null));

                        dispatch(setRuralAreas(null));
                      }}
                    >
                      {partState.parts &&
                        partState.parts.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب شهر"}
                      showArrow={true}
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      direction="rtl"
                      value={values.cityId}
                      key={4}
                      onSelect={(e, a) => {
                        setFieldValue("cityId", e);
                      }}
                      onClear={() => {
                        setFieldValue("cityId", null);
                      }}
                    >
                      {partState.cities &&
                        partState.cities.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب دهستان"}
                      showArrow={true}
                      allowClear
                      direction="rtl"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      value={values.ruralAreaId}
                      key={4}
                      onSelect={(e, a) => {
                        setFieldValue("villageId", null);
                        setFieldValue("ruralAreaId", e);
                        dispatch(villageClear(null));


                        dispatch(villageFetch({ ruralAreaId: e }));
                      }}
                      onClear={() => {
                        setFieldValue("ruralAreaId", null);
                        setFieldValue("villageId", null);
                        dispatch(villageClear(null));
                      }}
                    >
                      {partState.ruralAreas &&
                        partState.ruralAreas.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب روستا"}
                      showArrow={true}
                      allowClear
                      direction="rtl"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      value={values.villageId}
                      key={4}
                      onChange={(e, a) => {
                        setFieldValue("villageId", e);
                      }}
                      onClear={() => {
                        setFieldValue("villageId", null);
                      }}
                    >
                      {partState.villages &&
                        partState.villages.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h6 className="my-auto text-right mb-1rem">
                      فیلتر بر اساس سازمان و واحد سرمایه گذاری
                    </h6>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب سازمان"}
                      showArrow={true}
                      direction="rtl"
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      allowClear
                      value={values.organizationId}
                      key={4}
                      onSelect={(e, a) => {
                        dispatch(setUnits(null));
                        setFieldValue("organizationId", e);
                        setFieldValue("unitId", null);

                        const params = { organizationId: e };

                        dispatch(unitFetch(params));
                      }}
                      onClear={(e) => {
                        setFieldValue("organizationId", null);
                        setFieldValue("unitId", null);

                        dispatch(setUnits(null));
                      }}
                    >
                      {partState.organizations &&
                        partState.organizations.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12 col-md-3">
                    <Select
                      className="w-100 search-fields"
                      size="large"
                      placeholder={"انتخاب واحد"}
                      showArrow={true}
                      allowClear
                      direction="rtl"
                      value={values.unitId}
                      showSearch
                      filterOption={(input, option) =>
                        option.children.toLowerCase().match(input.toLowerCase())
                      }
                      key={4}
                      onSelect={(e, a) => {
                        setFieldValue("unitId", e);
                      }}
                      onClear={() => {
                        setFieldValue("unitId", null);
                      }}
                    >
                      {partState.units &&
                        partState.units.map((el) => {
                          return (
                            <Option className="text-right" value={el.id}>
                              {el.title}
                            </Option>
                          );
                        })}
                    </Select>
                  </div>
                  <div className="col-12">
                    <h6 className="my-auto text-right mb-1rem">
                      فیلتر بر اساس مبلغ
                    </h6>
                  </div>
                  <div
                    className="col-12 d-flex-column"
                    style={{ paddingInline: "25px" }}
                  >
                    <Slider
                      range
                      marks={marks}
                      tipFormatter={(e) => {
                        return `${e} میلیارد ریال`;
                      }}
                      min={1}
                      max={1000}
                      defaultValue={amount}
                      onAfterChange={(e) => {
                        setAmount(e);
                        setFieldValue("min", e[0]);
                        setFieldValue("max", e[1]);
                      }}
                    />
                  </div>
                </div>
                <div className="row justify-content-end">
                  <div className="col-12 col-md-4">
                    <Button
                      className="w-100"
                      style={{ height: "3rem", borderRadius: "6px" }}
                      onClick={() => {
                        dispatch(
                          potentialFetch({
                            title: values?.potentialTitle,
                            sectorId: values?.sectorId,
                            subSectorId: values?.subSectorId,
                            organizationId: values?.organizationId,
                            townshipId: values?.townshipId,
                            cityId: values?.cityId,
                            partId: values?.partId,
                          })
                        );
                        delete values.potentialTitle;
                        dispatch(oppFetch(values));
                        dispatch(setModalStats(false));
                        dispatch(advanceSearchValuesClear({}));
                        if (values.sectorId) {
                          searchLog({ sectorId: values.sectorId });
                        }
                        setFieldValue("sectorId", null);
                        setFieldValue("ruralAreaId", null);
                        setFieldValue("subSectorId", null);
                        setFieldValue("activityGroupId", null);
                        setFieldValue("productId", null);
                        setFieldValue("townshipId", null);
                        setFieldValue("partId", null);
                        setFieldValue("cityId", null);
                        setFieldValue("title", null);
                        setFieldValue("villageId", null);
                        setFieldValue("organizationId", null);
                        setFieldValue("potentialTitle", null);
                        setFieldValue("min", 1);
                        setFieldValue("max", 1000);
                        setAmount([1, 1000]);
                        setFieldValue("unitId", null);
                        dispatch(subSectorClear(null));
                        dispatch(agClear(null));
                        dispatch(productClear(null));
                        dispatch(partClear(null));
                        dispatch(ruralAreaClear(null));
                        dispatch(cityClear(null));
                        dispatch(setRuralAreas(null));
                        dispatch(villageClear(null));
                        dispatch(organizationClear(null));
                        dispatch(unitClear(null));
                      }}
                    >
                      جست و جو
                    </Button>
                  </div>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
};
